<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title>Zones d'exonération</span>
  <mat-dialog-content mat-dialog-content>
    <div class="dialog-header">
      <tiime-search-bar dark placeholder="N°INSEE Commune" [searchbarForm]="searchForm" />
      @if (searchErrorMessage) {
        <app-list-error [errorMessage]="searchErrorMessage" />
      }
      <div class="flex-spacer"></div>
      <a
        class="info-link"
        href="https://www.insee.fr/fr/recherche/recherche-geographique?debut=0"
        target="_blank"
        rel="noopener"
      >
        <button tiime-button strocked color="primary">
          Connaitre le n° INSEE d'une commune
          <mat-icon class="info-icon" color="primary" fontSet="fontastic" fontIcon="icon-open-in-new-window-2" />
        </button>
      </a>
    </div>
    <div class="dialog-table-container" #scrollContainer>
      <tiime-table-anchor></tiime-table-anchor>
      <table
        tiime-table
        tiimeStickyTable
        [scrollContainer]="scrollContainer"
        [dataSource]="rows"
        aria-label="Tableau des zones d'exonération"
      >
        <ng-container [cdkColumnDef]="ColumnNames.zone">
          <th cdk-header-cell *cdkHeaderCellDef>Zone Exonérations</th>
          <td cdk-cell *cdkCellDef="let row">
            <app-simple-cell [value]="row.zone" />
          </td>
        </ng-container>
        <ng-container [cdkColumnDef]="ColumnNames.result">
          <th cdk-header-cell *cdkHeaderCellDef>Résultats commune</th>
          <td cdk-cell *cdkCellDef="let row">
            <div>
              <app-simple-cell [class.with-result]="row.hasResult()" [value]="row.result()" />
              @if (row.resultPeriod(); as resultPeriod) {
                <app-simple-cell class="with-result" [value]="resultPeriod" />
              }
            </div>
          </td>
        </ng-container>
        <ng-container [cdkColumnDef]="ColumnNames.zoneReference">
          <th cdk-header-cell *cdkHeaderCellDef>Référence Zonage</th>
          <td cdk-cell *cdkCellDef="let row">
            <div>
              @for (ref of row.zoneReference; track $index; let index = $index) {
                <a [attr.href]="row.source[index]" target="_blank" rel="noopener">
                  <app-simple-cell [value]="ref" />
                </a>
              }
            </div>
          </td>
        </ng-container>
        <ng-container [cdkColumnDef]="ColumnNames.period">
          <th cdk-header-cell *cdkHeaderCellDef>Période d'application</th>
          <td cdk-cell *cdkCellDef="let row">
            <div>
              @for (period of row.period; track $index) {
                <app-simple-cell [value]="period" />
              }
            </div>
          </td>
        </ng-container>
        <ng-container [cdkColumnDef]="ColumnNames.site">
          <th cdk-header-cell *cdkHeaderCellDef>Site</th>
          <td cdk-cell *cdkCellDef="let row">
            @for (site of row.sites(); track i; let i = $index) {
              <a [attr.href]="site" target="_blank" rel="noopener">
                <mat-icon inline color="primary" fontSet="fontastic" fontIcon="icon-open-in-new-window-2" />
              </a>
            }
          </td>
        </ng-container>
        <tr *cdkHeaderRowDef="displayedColumns" cdk-header-row=""></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns; let even = even" [class.alternate]="even"></tr>
      </table>
    </div>
    <p>
      Toute utilisation des informations fournies dans cet annuaire se fait sous la responsabilité de l'utilisateur. Il
      est de la responsabilité de chaque utilisateur de s'assurer de l'exactitude et de la pertinence des données avant
      de les utiliser à des fins professionnelles.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" tiime-button color="accent" large raised (click)="cancel()">Fermer</button>
  </mat-dialog-actions>
</tiime-dialog>
